import { render, staticRenderFns } from "./Curriculums.vue?vue&type=template&id=86dd7b56&"
import script from "./Curriculums.vue?vue&type=script&lang=js&"
export * from "./Curriculums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports